/* RESPONSIBLE TEAM: team-inbox-management */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import type Inbox from './inbox';
import { InboxCategory } from 'embercom/models/data/inbox/inbox-categories';
import { InboxType } from 'embercom/models/data/inbox/inbox-types';
import { NamedIcon } from '../command-k/icons';

export type AllInboxWireFormat = {
  inbox_type: InboxType.All;
  count: number;
};

export default class All implements Inbox {
  readonly id = 'all';
  readonly category = InboxCategory.Shared;
  readonly type = InboxType.All;
  readonly count?: number;

  name = 'All';

  readonly translationKey = 'inbox.inbox-list.all';

  icon = new NamedIcon('multiple-people');

  constructor(count: number) {
    this.count = count;
  }

  static deserialize(json: AllInboxWireFormat): All {
    return new All(json.count);
  }
}
